// extracted by mini-css-extract-plugin
export var linkText = "_mr-0";